(() => {
  'use strict';
  if (window.MalfiniColorGallery) return;
  const cache = new Map(), requests = new WeakMap();
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const normalize = value => String(value || '').trim().toLocaleLowerCase('it');
  const safeImages = urls => [...new Set((urls || []).filter(url => {
    try { const parsed = new URL(url); return parsed.protocol === 'https:' && parsed.hostname === 'api.malfini.com' && parsed.pathname.startsWith('/image/'); } catch { return false; }
  }))];
  function load(url) {
    if (!url) return Promise.resolve({models:{}});
    if (!cache.has(url)) cache.set(url, fetch(url).then(response => {
      if (!response.ok) throw new Error('gallery');
      return response.json();
    }).then(data => {
      if (!data.models || data.schema_version !== 1) throw new Error('gallery');
      return data;
    }).catch(error => { cache.delete(url); throw error; }));
    return cache.get(url);
  }
  function images(data, model, colorCode) {
    return safeImages(data?.models?.[String(model).toUpperCase()]?.colors?.[colorCode]?.images);
  }
  async function mountNative(info, {model, colorName, url}) {
    if (!info || !model || !url) return;
    const fallback = () => {
      const wrapper = info.querySelector('.product__media-wrapper');
      const host = wrapper?.querySelector('[data-malfini-color-gallery]');
      const native = wrapper?.querySelector('media-gallery');
      if (host) host.hidden = true;
      if (native) native.hidden = false;
    };
    if (!colorName) { fallback(); return; }
    const request = {};
    requests.set(info, request);
    try {
      const data = await load(url);
      if (requests.get(info) !== request || !info.isConnected) return;
      const colors = data.models[String(model).toUpperCase()]?.colors;
      const entry = Object.entries(colors || {}).find(([, color]) => normalize(color.name) === normalize(colorName));
      const wrapper = info.querySelector('.product__media-wrapper');
      const native = wrapper?.querySelector('media-gallery');
      if (!entry || !native) { fallback(); return; }
      const photos = images(data, model, entry[0]);
      if (!photos.length) { fallback(); return; }
      let host = wrapper.querySelector('[data-malfini-color-gallery]');
      const identity = model + ':' + entry[0];
      if (host?.dataset.identity === identity) return;
      if (!host) {
        host = document.createElement('section');
        host.className = 'malfini-color-gallery';
        host.dataset.malfiniColorGallery = 'true';
        wrapper.prepend(host);
      }
      host.dataset.identity = identity;
      host.hidden = true;
      native.hidden = false;
      native.classList.add('malfini-original-media');
      const label = 'Modello ' + model + ' · ' + colorName;
      host.setAttribute('aria-label', 'Foto del capo · ' + colorName);
      host.innerHTML = '<div class="malfini-gallery-stage"><img data-gallery-main alt="' + escape(label + ' · vista 1') + '" width="400" height="400"></div>' +
        '<div class="malfini-gallery-thumbnails" role="group" aria-label="Viste del capo · ' + escape(colorName) + '">' + photos.map((src, index) =>
          '<button type="button" data-gallery-view="' + index + '" aria-label="Vista ' + (index + 1) + ' · ' + escape(colorName) + '" aria-pressed="' + (index === 0) + '"><img src="' + escape(src) + '" alt="" width="72" height="72" loading="lazy"></button>').join('') + '</div>' +
        '<p class="malfini-gallery-caption" data-gallery-caption aria-live="polite"></p>';
      const image = host.querySelector('[data-gallery-main]');
      const buttons = [...host.querySelectorAll('[data-gallery-view]')];
      const caption = host.querySelector('[data-gallery-caption]');
      let index = 0;
      const show = next => {
        index = next;
        image.alt = label + ' · vista ' + (index + 1);
        caption.textContent = colorName + ' · Vista ' + (index + 1) + ' di ' + photos.length;
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        image.onload = () => {
          if (host.dataset.identity !== identity || !info.isConnected || !image.isConnected) return;
          host.hidden = false;
          native.hidden = true;
        };
        image.onerror = () => {
          if (host.dataset.identity !== identity) return;
          host.hidden = true;
          native.hidden = false;
        };
        image.src = photos[index];
      };
      buttons.forEach((button, i) => {
        button.onclick = () => show(i);
        button.onkeydown = event => {
          if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + photos.length) % photos.length;
          buttons[next].focus();
          show(next);
        };
        button.querySelector('img').onerror = () => { button.disabled = true; };
      });
      show(0);
    } catch { /* Keep the native gallery when supplementary images are unavailable. */ }
  }
  window.MalfiniColorGallery = {load, images, mountNative};
})();
